import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <div className='bg-gradient-to-r from-black to-gray-800 py-6 text-white'>
            <div className="max-w-screen-xl mx-auto px-4 text-center">
                {/* Title Section */}
                <p className='text-white font-semibold text-[20px] mb-4'>
                    Shambhuraj Khamkar's Trading Academy
                </p>

                {/* Links Section */}
                <div className='flex flex-col sm:flex-row justify-center items-center text-[10px] sm:text-[12px] text-gold1 mb-6'>
                    <Link to="/privacy" className='hover:text-yellow-500 transition-all duration-300 ease-in-out'>
                        Privacy Policy &nbsp;|
                    </Link>

                    <Link to="/terms" className='hover:text-yellow-600 transition-all duration-300 ease-in-out'>
                        &nbsp; Terms
                    </Link>
                </div>

                {/* Introductory Text Section */}
                <p className='text-[10px] sm:text-[12px] mb-4 italic'>
                    By accessing and using this landing page, you acknowledge and agree to the following terms and conditions:
                </p>

                {/* Terms List Section */}
                <ol className="space-y-4 text-[10px] sm:text-[12px] mx-4 sm:mx-12 sm:text-center">
                    <li>
                        <strong>Educational Purpose:</strong> The content provided on this landing page, including but not limited to images, text, and other materials, is for educational purposes only. It is not intended as financial or investment advice. Participants are encouraged to conduct their research and consult with a qualified financial professional before making any investment decisions.
                    </li>
                    <li>
                        <strong>No Guarantee of Results:</strong> Past performance is not indicative of future results. The information presented in this one-to-one meeting does not guarantee any specific financial outcome or success in the stock market. Participants should be aware of the risks involved in trading and investing.
                    </li>
                    <li>
                        <strong>Use of Images and Materials:</strong> All images, logos, and other materials used on this landing page are either owned by the organizers or used under appropriate licenses. Any unauthorized use or reproduction of these materials is strictly prohibited.
                    </li>
                    <li>
                        <strong>No Endorsement:</strong> Mention of third-party products, services, or websites on this landing page does not constitute an endorsement or recommendation. Participants are advised to exercise their judgment before engaging with any external links or services.
                    </li>
                    <li>
                        <strong>Limitation of Liability:</strong> The organizers of this one-to-one call are not liable for any losses, damages, or injuries arising from the use of information provided on this landing page. Participants engage at their own risk.
                    </li>
                    <li>
                        <strong>Changes to Terms:</strong> The organizers reserve the right to modify or update these terms and conditions at any time without prior notice. It is the responsibility of participants to review the terms regularly.
                    </li>
                </ol>

                {/* Final Agreement Text */}
                <p className='mt-6 mx-12 text-[10px] sm:text-[12px]'>
                    By accessing and using this landing page, you agree to abide by these terms and conditions. If you do not agree with any part of these terms, please refrain from using this platform.
                </p>
            </div>
        </div>
    )
}

export default Footer;
